import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
            <span className="w-6 h-px bg-primary-400" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold tracking-tight text-foreground-950">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}